import { isNotEmpty, numberToABC } from '@doltech/utils/lib/text';
import cl from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { QuestionCircle, QuestionDisplayMode } from '../../CircleText/CircleText';
import { colorsV2 } from '../../colors-v2';
import { SubText } from '../../Typography';
import { QuestionV2 } from '../../Question/QuestionV2';

export interface BlankChange {
  text: string;
  blankId: string;
}

interface BlankProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  blankId?: string;
  no: number;
  value?: string;
  onChange?: (input: any) => void;
  onRemoveBlank?: (changes: BlankChange) => void;
  disabled?: boolean;
  showRemoveButton?: boolean;
  showDropZone?: boolean;
  onClick?: any;
  isMobile?: boolean;
  optionNo?: number;
}

const BlankMobile = (props: BlankProps) => {
  const { id, no, value, onClick = noop, disabled, blankId, className, optionNo, ...rest } = props;

  const hasValue = isNotEmpty(value);

  return (
    <ThemeProvider theme={{ hasValue }}>
      <Container onClick={() => onClick(blankId, id)} id={id} {...rest}>
        <QuestionV2 no={no} marginRight={0} />
        <QuestionCircle
          className={cl(QuestionDisplayMode.QUESTION_OPTION_DASHED, { selected: hasValue })}
        >
          <SubText>{hasValue ? numberToABC(optionNo + 1) : ''}</SubText>
        </QuestionCircle>
      </Container>
    </ThemeProvider>
  );
};

const Container = styled.div`
  user-select: none;
  display: inline-grid;
  column-gap: 8px;
  grid-template-columns: max-content;
  grid-auto-flow: column;
  padding: 2px 0;
  background-color: ${colorsV2.white100};
  border-radius: 8px;
  transition: 300ms;
`;

export default React.memo(BlankMobile);
